module.exports = __webpack_public_path__ + "static/img/kkrn_icon_onsei_4.c1b23d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2026/kkrn_icon_onsei_4.png
// module id = BCwb
// module chunks = 1